/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumLoginDetailsProvenienzaLogin =
  (typeof EnumLoginDetailsProvenienzaLogin)[keyof typeof EnumLoginDetailsProvenienzaLogin];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumLoginDetailsProvenienzaLogin = {
  FRONTOFFICE: 'FRONTOFFICE',
  BACKOFFICE: 'BACKOFFICE',
  CONFIGURATORE: 'CONFIGURATORE',
} as const;
